module.exports = __webpack_public_path__ + "static/media/12576259_1301609276532028_112854864_n.ba8c4c48.jpg";